export const HOST = 'https://registration.rent-ln.co.uk/api'
// export const HOST = 'http://0.0.0.0:8080/api';
// export const HOST = `${window.location.protocol}//${window.location.host}/api`;